import {ISliderState} from 'modules/slider/types';
import {AnyAction, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const sliderModuleName = 'slider';

const initialState: ISliderState = {
    activeIdx: 0,
    autoStartVideoPath: null,
};

export const sliderSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return {
                ...payload[sliderModuleName],
                activeIdx: state.activeIdx,
            };
        });
    },
    initialState,
    name: sliderModuleName,
    reducers: {
        actionSetActiveIdx(state: ISliderState, {payload}: PayloadAction<ISliderState['activeIdx']>) {
            state.activeIdx = payload;
        },

        actionSetAutoStartVideoPath(state: ISliderState, {payload}: PayloadAction<ISliderState['autoStartVideoPath']>) {
            state.autoStartVideoPath = payload;
        },
    },
});

export const {
    actions: {actionSetActiveIdx, actionSetAutoStartVideoPath},
} = sliderSlice;

export const {reducer: sliderReducer} = sliderSlice;
